import highlight from './highlight'

const install = function (Vue) {
  window.$vueApp.directive('highlight', highlight)
}

if (window.Vue) {
  window['highlight'] = highlight
  window.$vueApp.use(install) // eslint-disable-line
}

export default install
